import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'

const StyledComponent = styled(({css, ...rest}) => <div {...rest} />)`
  font-size: 15px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.47;
  letter-spacing: normal;
  color: #333333;
  color: var(--nav-active);
  border-top: 1px rgba(215,216,218,0.51) solid;
  padding: ${p => p.theme.s} ${p => p.theme.m};
  margin-bottom: ${p => p.mb || p.theme.s};

  ${p => p.css};
`

const _CardTitle = (props) => <StyledComponent {...props} />
_CardTitle.propTypes = {
  css: PropTypes.oneOfType(
    [
      PropTypes.string,
      PropTypes.array
    ]
  ),
}

export default _CardTitle

